// This script is used to change the theme of the website from dark to light and vice versa.


const THEMES = ["light", "dark"];
const PREFERED_THEME = "dark";
const LOCALSTORAGE_PREFIX = "bsTheme"

function getPreferredTheme() {
  return PREFERED_THEME;
}

function getOtherTheme() {
  return THEMES.find((theme) => theme !== getPreferredTheme());
}

function getLocalStoragePrefix() {
  return LOCALSTORAGE_PREFIX || "bsTheme";
}

function getSystemTheme() {
  const preferdTheme = getPreferredTheme();
  const otherTheme = getOtherTheme();
  return window.matchMedia(`(prefers-color-scheme: ${preferdTheme})`).matches ? preferdTheme : otherTheme;
}

function getStoredTheme() {
  return localStorage.getItem(`${getLocalStoragePrefix()}-theme_mode`) || null;
};

function storeTheme(theme) {
  localStorage.setItem(`${getLocalStoragePrefix()}-theme_mode`, theme);
}


const themeMode = getStoredTheme() || getPreferredTheme() || getSystemTheme();

const html = document.querySelector("html");
html.dataset.bsTheme = themeMode;
storeTheme(themeMode);

const triggerThemeChange = document.querySelector("#triggerThemeChange");

if (triggerThemeChange) {
  // Set initial button state
  if (themeMode === "dark") {
    triggerThemeChange.innerHTML = '<i class="fas fa-sun"></i>';
    triggerThemeChange.classList.remove("btn-light");
    triggerThemeChange.classList.add("btn-dark");
    // Ensure body class is added/removed appropriately if not already handled
    if(!document.body.classList.contains('dark-mode')) document.body.classList.add('dark-mode');
  } else {
    triggerThemeChange.innerHTML = '<i class="fas fa-moon"></i>';
    triggerThemeChange.classList.remove("btn-dark");
    triggerThemeChange.classList.add("btn-light");
     if(document.body.classList.contains('dark-mode')) document.body.classList.remove('dark-mode');
  }
  
  // Add click handler
  triggerThemeChange.addEventListener("click", function() {
    const currentMode = html.dataset.bsTheme;
    const newMode = currentMode === "dark" ? "light" : "dark";
    
    html.dataset.bsTheme = newMode;
    document.body.classList.toggle('dark-mode');
    
    if (newMode === "dark") {
      triggerThemeChange.innerHTML = '<i class="fas fa-sun"></i>';
      triggerThemeChange.classList.remove("btn-light");
      triggerThemeChange.classList.add("btn-dark");
    } else {
      triggerThemeChange.innerHTML = '<i class="fas fa-moon"></i>';
      triggerThemeChange.classList.remove("btn-dark");
      triggerThemeChange.classList.add("btn-light");
    }
    
    storeTheme(newMode);
  });
} else {
  console.warn('Theme toggle button (#triggerThemeChange) not found on this page.');
}
